export const GET_REQUESTTYPES_BEGIN = "GET_REQUESTTYPES_BEGIN";
export const GET_REQUESTTYPES_SUCCESS = "GET_REQUESTTYPES_SUCCESS";
export const GET_REQUESTTYPES_ERROR = "GET_REQUESTTYPES_ERROR";

export const DELETE_REQUESTTYPE_BEGIN = "DELETE_REQUESTTYPE_BEGIN";
export const DELETE_REQUESTTYPE_SUCCESS = "DELETE_REQUESTTYPE_SUCCESS";
export const DELETE_REQUESTTYPE_ERROR = "DELETE_REQUESTTYPE_ERROR";

export const CREATE_REQUESTTYPE_BEGIN = 'CREATE_REQUESTTYPE_BEGIN'
export const CREATE_REQUESTTYPE_SUCCESS = 'CREATE_REQUESTTYPE_SUCCESS'
export const CREATE_REQUESTTYPE_ERROR = 'CREATE_REQUESTTYPE_ERROR'

export const UPDATE_REQUESTTYPE_BEGIN = 'UPDATE_REQUESTTYPE_BEGIN'
export const UPDATE_REQUESTTYPE_SUCCESS = 'UPDATE_REQUESTTYPE_SUCCESS'
export const UPDATE_REQUESTTYPE_ERROR = 'UPDATE_REQUESTTYPE_ERROR'